import React from 'react';
import {
  Button
} from 'reactstrap';

const LCTA = () => {
  return (
    <div className="cta bg-primary text-center text-white">
      <h1 className="text-white">Try Lazy Kit for free</h1>
      <p className="lead">Do you like how this kit looks? See what you can built with it!</p>
      <Button href="https://bootstrapbay.com/theme/lazy-free-react-ui-kit-BD90DEB" color="white" size="lg" className="mt-4">Download</Button>
    </div>
  );
};

export default LCTA;
